module.exports = require("@tiptap/extension-text-style");